import { render, staticRenderFns } from "./screen-waterQuality.vue?vue&type=template&id=774e0ebd&scoped=true"
import script from "./screen-waterQuality.vue?vue&type=script&lang=js"
export * from "./screen-waterQuality.vue?vue&type=script&lang=js"
import style0 from "./screen-waterQuality.vue?vue&type=style&index=0&id=774e0ebd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774e0ebd",
  null
  
)

export default component.exports